import React from 'react';
import { Card } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { primaryShades } from '../../../theme/theme';
import CustomTooltip from '../Modals/CustomTooltip';

// Costanti dei colori
const PRIMARY_200 = primaryShades.primary200;
const PRIMARY_500 = primaryShades.primary500;
const WHITE = '#ffffff';
const BOX_SHADOW_COLOR = 'rgba(0, 0, 0, 0.08)';

/**
 * Componente CustomCard personalizzabile
 * @param {string} title - Titolo della card
 * @param {React.ReactNode} icon - Icona da visualizzare accanto al titolo
 * @param {React.ReactNode} children - Contenuto della card
 * @param {string} backgroundColor - Colore di sfondo della card
 * @param {string} headerColor - Colore dell'intestazione
 * @param {string} textColor - Colore del testo
 * @param {string|number} height - Altezza della card
 * @param {boolean} showTooltip - Mostra/nascondi tooltip
 * @param {string} tooltipText - Testo del tooltip
 */
const CustomCard = ({
    title,
    icon,
    children,
    backgroundColor = WHITE,
    headerColor = PRIMARY_200,
    textColor = PRIMARY_500,
    height = 'auto',
    showTooltip = true,
    tooltipText = "Card information"
}) => {
    return (
        <Card
            style={{
                borderRadius: 'clamp(0.25rem, 2vw, 0.5rem)',
                overflow: 'hidden',
                height: height,
                boxShadow: `0 clamp(0.0625rem, 0.5vw, 0.125rem) clamp(0.25rem, 2vw, 0.5rem) ${BOX_SHADOW_COLOR}`,
                backgroundColor: backgroundColor,
            }}
            styles={{ body: { padding: title ? 0 : 'clamp(0.75rem, 4vw, 1.25rem)', height: '100%' } }}
        >
            {title ? (
                <>
                    <div style={{
                        backgroundColor: headerColor,
                        padding: 'clamp(0.5rem, 2vw, 0.625rem) clamp(0.75rem, 3vw, 0.9375rem)',
                        textAlign: 'left',
                        fontWeight: 'bold',
                        position: 'relative',
                        fontSize: 'clamp(0.75rem, 2vw, 0.875rem)',
                        color: textColor,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between'
                    }}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            {icon && <span style={{ marginRight: 'clamp(0.25rem, 2vw, 0.5rem)' }}>{icon}</span>}
                            {title}
                        </div>
                        {showTooltip && (
                            <CustomTooltip title={tooltipText}>
                                <InfoCircleOutlined
                                    style={{
                                        fontSize: 'clamp(0.75rem, 2vw, 0.875rem)',
                                        color: textColor
                                    }}
                                />
                            </CustomTooltip>
                        )}
                    </div>
                    <div style={{
                        padding: 'clamp(0.75rem, 4vw, 1.25rem)',
                        height: 'calc(100% - 2.5rem)',
                    }}>
                        {children}
                    </div>
                </>
            ) : (
                children
            )}
        </Card>
    );
};

export default CustomCard; 